import { Link } from '@nerdwallet/currency';
export default Link;